'use client';

import { useEffect } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let appInsights: ApplicationInsights | null = null;

export function AzureInsights() {
  useEffect(() => {
    const connectionString = process.env.APPINSIGHTS_CONNECTION_STRING;
    if (!connectionString || appInsights) return;

    appInsights = new ApplicationInsights({
      config: {
        connectionString,
        enableAutoRouteTracking: true, // track SPA navigation
        enableCorsCorrelation: true,
        disableFetchTracking: false,
        // Ne pas utiliser l'événement "unload"
        disablePageUnloadEvents: ['unload', 'beforeunload'],
      },
    });

    appInsights.loadAppInsights();
    appInsights.trackPageView();
  }, []);

  return null;
}
